import { render, staticRenderFns } from "./edit-profile-photos.vue?vue&type=template&id=4408a97e&"
import script from "./edit-profile-photos.vue?vue&type=script&lang=js&"
export * from "./edit-profile-photos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports